import React, { useEffect, useState } from 'react';
import { getSecret } from '@delta-defense/ail-sdk/sdk/features/secret/secret.get';

import Loading from '../Loading/Loading';
import SingleSignOn from '../SingleSignOn/SingleSignOn';
import {
  removeElementById,
  setBackgroundByClass
} from '../../utilities/module';
import { backgroundColor, QueryParams, styleClassNames, svgIds } from '../../constants';
import { Cookies, CookieService } from '../../core/services/cookieService';
import { getRedirectTo } from '../../utilities/getRedirectTo';

type LoadingSpinnerProps = {
  removeSvg?: boolean;
  setBg?: boolean;
  svgId?: string;
  backgroundClass?: string;
  backgroundColor?: string;
};

export function LoadingSpinner({
  removeSvg = false,
  setBg = false,
  svgId,
  backgroundClass,
  backgroundColor
}: LoadingSpinnerProps) {
  useEffect(() => {
    removeSvg && removeElementById(svgId || '');
    setBg && setBackgroundByClass(backgroundClass || '', backgroundColor || '');
  }, [removeSvg, setBg, svgId, backgroundClass, backgroundColor]);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        zIndex: 10
      }}
    >
      <Loading size="3x" />
    </div>
  );
}

function RedirectChecker({
  cookieService = CookieService.Instance(),
  SingleSignOnComponent = SingleSignOn
}) {
  const [authChecked, setAuthChecked] = useState(false);
  const [accessTokenExpired, setAccessTokenExpired] = useState(false);
  const [userId, setUserId] = useState('');
  const [accessToken, setAccessToken] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const secretToken = new URLSearchParams(window.location.search).get(QueryParams.SecretToken);
        if (secretToken) {
          const secretResponse = await getSecret({ key: secretToken }) as any;
          const accessToken = secretResponse.secret;
          const accessTokenObject = cookieService.decodeToken(accessToken);

          if (accessTokenObject.exp) {
            await cookieService.setAccessToken(accessToken, accessTokenObject.exp);
          }
        }
      } catch (error) {
        console.error('Unable to access secretToken', error);
      }
      const accessToken = await cookieService.getRaw(Cookies.USCCA_Access);

      setAccessTokenExpired(!accessToken);

      const userId = cookieService.decodeToken(accessToken)?.userId || '';

      setUserId(userId);
      setAccessToken(accessToken);

      if (accessTokenExpired || !userId) {
        await cookieService.deleteAuthCookies();
      }
      setAuthChecked(true);
    })();
  }, []);

  if (authChecked && (accessTokenExpired || !userId)) {
    return (
      <>
        <LoadingSpinner />
        <SingleSignOnComponent
          action="logout"
          redirect_url={getRedirectTo('logout')}
        />
      </>
    );
  } else {
    return (
      <>
        <LoadingSpinner
          removeSvg={true}
          setBg={true}
          svgId={svgIds.cabelas}
          backgroundClass={styleClassNames.cabelas}
          backgroundColor={backgroundColor.cabelas}
        />

        {accessToken &&
          <SingleSignOnComponent
            action="login"
            redirect_url={getRedirectTo()}
            uscca_access={accessToken}
          />
        }
      </>
    );
  }
}

export default RedirectChecker;
